import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgEcologyOrganicOutline = function SvgEcologyOrganicOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.75C3 3.33579 3.33579 3 3.75 3H5C8.80035 3 11.9618 5.73541 12.6229 9.34475C14.0216 7.32382 16.3562 6 19 6H20.25C20.6642 6 21 6.33579 21 6.75V8.25C21 12.5302 17.5302 16 13.25 16H12.75V20.25C12.75 20.6642 12.4142 21 12 21C11.5858 21 11.25 20.6642 11.25 20.25V12.75H10.75C6.4698 12.75 3 9.2802 3 5V3.75ZM11.25 11.25H10.75C7.29822 11.25 4.5 8.45178 4.5 5V4.5H5C8.45178 4.5 11.25 7.29822 11.25 10.75V11.25ZM12.75 14.5H13.25C16.7018 14.5 19.5 11.7018 19.5 8.25V7.5H19C15.5482 7.5 12.75 10.2982 12.75 13.75V14.5Z"
  })));
};

export { SvgEcologyOrganicOutline as ReactComponent };
//# sourceMappingURL=ecology--organic-outline.svg.js.map
